<template>
    <div id="main">
        <div class="platform-header">
            <div class="platform-logo-container">
                <img class="platform-logo-container__logo" src="../assets/images/Login/resource-platform-logo.png"/>
                <div class="title platform-logo-container__title">{{areaName}}德育在线平台</div>
            </div>
            <div class="platform-top-nav">
                <ul class="nav_item_container clearfix">
                    <li class="nav-item">
                        <router-link to="/main/resourceIndex" class="nav-item__link">首页
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="checkIndexPermission(permission, '/videoResourcePlatform/videoResourcePlatformAdmin')">
                        <router-link to="/main/resourceManagement" class="nav-item__link">资源管理
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="checkIndexPermission(permission, '/videoResourcePlatform/schoolResourceForAccount')">
                        <router-link to="/main/schoolAccount" class="nav-item__link">校级统计
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="checkIndexPermission(permission, '/videoResourcePlatform/videoResourcePlatformAccountant')">
                        <router-link to="/main/accounting" class="nav-item__link">数据统计
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="checkIndexPermission(permission, '/videoResourcePlatform/moralOLManagerSet')">
                        <router-link to="/main/system" class="nav-item__link">系统设置
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="platform-user">
                <el-dropdown trigger="click">
                    <div class="platform-user__avatar-container">
                        <div class="platform-user__avatar-inner clearfix"><img
                            :src="userInfo.avatar"
                            class="platform-user__avatar">
                            <div class="platform-user__name">
                                {{userInfo.name}}
                            </div>
                            <i class="el-icon-caret-bottom"></i>
                        </div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span @click="logout" style="display:block;">退出登录</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>
        </div>
        <div class="module-container">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin.js'
    import {mapGetters} from 'vuex';

    export default {
        name: "Main",
        mixins: [baseMixin],
        data() {
            return {
                areaName: ''
            }
        },
        computed: {
            ...mapGetters(['userInfo', 'permission'])
        },
        mounted() {
            let areaName = '';
            switch(window.location.host) {
                case 'xwdyzx.weixiaojia.cn':
                    areaName = '玄武';
                    break;
                case 'zy.lhedu.com.cn':
                    areaName = '六合';
                    break;
                default:
                    areaName = '玄武';
                    break;
            }
            this.areaName = areaName;
        },
        methods: {
            logout() {
                this.$store.dispatch('LogOut').then(() => {
                    // location.reload();// 为了重新实例化vue-router对象 避免bug
                    this.$router.push('/login')
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
<style lang="scss">
    .router-link-active {
        color: #20a0ff !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/Main.vue